module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sales_funnel":"Sales Funnel","campaign_ranking":"Campaign Ranking","fundraiser_ranking":"Fundraiser Ranking"},"id":{"sales_funnel":"Funnel Penjualan","campaign_ranking":"Peringkat Kampanye","fundraiser_ranking":"Peringkat Penggalang Dana"}}')
  delete Component.options._Ctor
}
